// extracted by mini-css-extract-plugin
export var button = "_cv-0";
export var donut = "_cv-1";
export var donutFill = "_cv-3";
export var donutTrack = "_cv-2";